var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer-background py-4 mt-5" }, [
    _vm.footerLogoSrc
      ? _c("img", {
          staticClass: "mx-auto mt-3 mb-4 d-block",
          attrs: {
            alt: _vm.footerLogoAlt,
            height: _vm.footerLogoHeight,
            src: _vm.footerLogoSrc,
            width: _vm.footerLogoWidth
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-lg-flex justify-content-center text-center text-secondary"
      },
      [
        _c("div", { staticClass: "font-weight-bold pr-4 py-1" }, [
          _vm._v("\n      " + _vm._s(_vm.phoneNumber) + "\n    ")
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]
    ),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "working-hours" }, [
      _c("span", { staticClass: "working-hours__text py-1" }, [
        _vm._v("Monday through Friday 7:00 am - 7:00 pm")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "px-3 working-hours__separator" }, [
        _vm._v("-")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "working-hours__text py-1" }, [
        _vm._v(" Saturday 9:00 am - 5:00 pm Mountain Time")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        { staticClass: "text-secondary footer-links my-sm-3 my-md-1" },
        [
          _c(
            "a",
            {
              staticClass: "brand-primary-color text-decoration-none",
              attrs: {
                href: "https://www.autopay.com/terms-conditions",
                target: "_blank",
                rel: "noreferrer"
              }
            },
            [_vm._v("Terms & Conditions")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "brand-primary-color text-decoration-none",
              attrs: {
                href: "https://www.autopay.com/privacy-policy",
                target: "_blank",
                rel: "noreferrer"
              }
            },
            [_vm._v("Privacy Policy")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "brand-primary-color text-decoration-none",
              attrs: {
                href: "https://www.autopay.com/legal-disclaimer",
                target: "_blank",
                rel: "noreferrer"
              }
            },
            [_vm._v("Legal & Disclaimers")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "brand-primary-color text-decoration-none",
              attrs: {
                href: "https://www.autopay.com/terms",
                target: "_blank",
                rel: "noreferrer"
              }
            },
            [_vm._v("Terms Of Use")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "brand-primary-color text-decoration-none",
              attrs: {
                href: "https://www.autopay.com/privacy-rights",
                target: "_blank",
                rel: "noreferrer"
              }
            },
            [_vm._v("Privacy Rights")]
          )
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "copyright-text" }, [
        _vm._v("\n      © The Savings Group, Inc. All Rights Reserved.\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }